import i18n from '@/lang/i18n'
import {
    initialReportsModalFormRangeFilter,
    ReportsModalFormRangeFilterState
} from '@/modules/RegistryModule/views/editCase/modals/reports-modal-form/components/reports-modal-form-range-filter/reports-modal-form-range-filter.model'
import {
    initialReportsModalFormContentFilter,
    ReportsModalFormContentFilterState
} from '@/modules/RegistryModule/views/editCase/modals/reports-modal-form/components/reports-modal-form-content-filter/reports-modal-form-content-filter.model'
import { Nullable } from '@/shared/types/app.types'
import { CommonResource } from '@/api/resources/common/shared/models/common.models'

export enum ReportTypeEnum {
    APA_REPORT = 'APA_REPORT',
    PATIENT_CASES = 'PATIENT_CASES'
}

export enum RangeTypeEnum {
    REQUEST_DATE = 'REQUEST_DATE',
    REGISTRY_DATE = 'REGISTRY_DATE',
    INFORMED_DATE = 'INFORMED_DATE',
    VALIDATED_DATE = 'VALIDATED_DATE',
    CASE_NUMBER = 'CASE_NUMBER'
}

export interface DefaultComboOption {
    id: string,
    label: string
}

export const ReportTypes: DefaultComboOption[] = [
    { id: ReportTypeEnum.APA_REPORT, label: i18n.tc('registry.modal.reports.pathologicalReports') },
    { id: ReportTypeEnum.PATIENT_CASES, label: i18n.tc('registry.modal.reports.patientCases') }
]

export interface ReportsModalFormState {
    reportType: DefaultComboOption
    range: ReportsModalFormRangeFilterState
    content: ReportsModalFormContentFilterState
    pdfB64: Nullable<CommonResource>
    pdfFileName: string
    filterModel: Nullable<any>
    comboOptions: {
        reportTypes: DefaultComboOption[]
    }
}
export const initialReportsModalForm =
    (): ReportsModalFormState => ({
        reportType: ReportTypes[0],
        range: initialReportsModalFormRangeFilter(),
        content: initialReportsModalFormContentFilter(),
        pdfB64: null,
        pdfFileName: '',
        filterModel: null,
        comboOptions: {
            reportTypes: ReportTypes
        }
    })
